import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import './ContentStyle.css';
import ApiSender from '../common/ApiLogic';
import { appendParams } from '../common/urlUtils';
import { v4 as uuidv4 } from "uuid";

function SubscribePage() {

  const nav = useNavigate();
  const location = useLocation();
  const [msisdn, setMsisdn] = useState(null);
  const [warning, setWarning] = useState(false);
  const [code, setCode] = useState(null);
  const [goalId, setGoalId] = useState(null);
  const [goalName, setGoalName] = useState(null);
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const paramsObject = {};
  for (const [key, value] of params.entries()) {
    paramsObject[key] = value;
  }

  useEffect(() => {
    async function begin() {
      const landingPageUrl = window.location.origin + location.pathname;
      const apiSender = new ApiSender();
      apiSender.saveHistory(landingPageUrl, paramsObject);

      let gi = null;
      let gn = null;
      const goalInfoResult = await apiSender.getGoalsInfo(paramsObject);
      if (goalInfoResult.success) {
        gi = goalInfoResult.goalId;
        gn = goalInfoResult.goalName;
        setGoalId(gi);
        setGoalName(gn);
      }

      document.getElementById('subscribe-btn').disabled = true;
      document.getElementById('loading-spinner-he').style.display = 'inline-flex';
      const msisdnDetectedResult = await apiSender.getMsisdnFromHeader();
      if (msisdnDetectedResult.success) {
        const m = msisdnDetectedResult.msisdn;
        setMsisdn(m);

        const foSubscribeResult = await apiSender.heFoSubscribe(m, paramsObject);
        if (foSubscribeResult.success) {
          const code = foSubscribeResult.code;
          setCode(code);
          if (code != null && code !== undefined && code === 2000) {
            const heId = uuidv4() + "-" + msisdn;
            const subscribeResult = await apiSender.heSubscribe(m, heId, gi, gn, landingPageUrl, "Kenya Main LP", paramsObject);
            if (subscribeResult.success) {
              const url = subscribeResult.url;
              if (url) {
                window.location.replace(appendParams(url, `heId=${encodeURIComponent(heId)}`));
                return;
              }
            }
            document.getElementById('subscribe-btn').disabled = false;
            document.getElementById('loading-spinner-he').style.display = 'none';
            document.getElementById('warning-msg').textContent = subscribeResult.message;
            setWarning(true);
            return;
          }
        }
        document.getElementById('loading-spinner-he').style.display = 'none';
        document.getElementById('subscribe-btn').disabled = false;
      } else {
        nav(`/failed`);
      }
    }
    begin();
  }, []);

  const handleSubscribe = async () => {
    document.getElementById('subscribe-btn').disabled = true;
    document.getElementById('loading-spinner').style.display = 'inline-flex';
    setWarning(false);
    const landingPageUrl = window.location.origin + location.pathname;
    const heId = uuidv4() + "-" + msisdn;
    const apiSender = new ApiSender();
    const subscribeResult = await apiSender.heSubscribe(msisdn, heId, goalId, goalName, landingPageUrl, "Kenya Main LP", paramsObject);
    if (subscribeResult.success) {
      const url = subscribeResult.url;
      if (url) {
        window.location.replace(appendParams(url, `heId=${encodeURIComponent(heId)}`));
        document.getElementById('loading-spinner').style.display = 'none';
        return;
      }
    }
    document.getElementById('subscribe-btn').disabled = false;
    document.getElementById('warning-msg').textContent = subscribeResult.message;
    document.getElementById('loading-spinner').style.display = 'none';
    setWarning(true);
  }

  return (
    <div className="Aa000">
      <div className='container'>
        <div className='header'>
          <div className='logo'><img alt='GameLand' src='%PUBLIC_URL%/../../gameland-logo.png' /></div>
        </div>
        <div className='form-content'>
          <div className='form-content-top'>
            <div className='logo'><img alt='GameLand' src='%PUBLIC_URL%/../../gameland-banner.png' /></div>
          </div>
          <div className="subscribe-content">
            <div className="input">
              <div className='title'>
                <h4>Click here to subscribe</h4>
              </div>
              <button id="subscribe-btn" className="button" onClick={handleSubscribe}>
                Subscribe
                <div id="loading-spinner" className="spinner"></div>
              </button>
              <div id="loading-spinner-he" className="spinner"></div>
              <div id='warning-msg-div' className={`warning-msg ${warning ? 'active' : ''}`}>
                <span id='warning-msg'></span>
              </div>
            </div>
            <div className="terms" style={{ direction: "rtl" }}>
              <p>Subscription price is 15 Ksh/day with 1-day free trial (automatically renewed). To unsubscribe send STOP to 27806. For support contact <a href='mailto:support@ke-gameland.com'>support@ke-gameland.com</a></p>
              <br></br>
              <a href='#'><Link to={`/terms`}>Terms and Condition</Link></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscribePage;